import React from 'react';
import { graphql, compose } from 'react-apollo';
import AllTimeRevivalDatesWidget from '../../../../widgets/allTime/allTimeRevivalDatesWidget';
import { getPrayingStatistics } from './queries/queries';
import { ByDayPrayingTimeDistribution } from '../../common/charts/byDayPrayingTimeDistribution';
import DataProcessor from '../../common/dataProcessors/prayingDataProcessor';
import PrayingWidget from '../../common/widgets/praying';
import { ErrorBoundary } from "../../../../errorBoundary/errorBoundary";

class Praying extends AllTimeRevivalDatesWidget {
  get statisticsData() {
    return this.props.data.statistics.churchManager.group.allTime.praying;
  }

  get dataProcessor() {
    return new DataProcessor(this.apiData, 'all time');
  }

  render() {
    return (
      <PrayingWidget data={this.dataProcessor.data} loading={this.props.data.loading} title="All Time Praying"
                     comment={this.comment}>
        <ByDayPrayingTimeDistribution data={this.dataProcessor.chartData}
                                      pointTooltip={this.dataProcessor.pointTooltip}
                                      tickValues={this.tickValues}
                                      tickFormat={this.tickFormat} />
      </PrayingWidget>
    )
  }
}

export default compose(
  graphql(getPrayingStatistics,
    {
      options: {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true //e.vasilevsky TODO: make it default after updating react-apollo to the latest version
      }
    }),
  ErrorBoundary
)(Praying);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/group/allTime/praying.js